import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${require('assets/images/icon-ghost-grey.png')});
  background-repeat: no-repeat;
  background-origin: border-box;
  background-position-y: center;
  display: flex;
  flex-direction: column;
  position: fixed;
  background-color:  #fff;
  z-index: -1;
  left: -15px;

  @media (max-width: 1024px) {
    left: unset;
    ${(props) => props.noMobile && 'background-image: none;'}
  }
`;

export default Wrapper;
